
import { defineComponent, onMounted, computed, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import VPagination from "@hennge/vue3-pagination";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import AppService from "@/core/services/AppService";
import { renderImageUrl } from "@/core/services/AppService";
import { Select } from "@element-plus/icons";
export default defineComponent({
  name: "Experience-list",
  components: { VPagination },
  props: {
    page: {
      type: String,
      default: "1",
    },
    limit: {
      type: String,
      default: "20",
    },
    email: {
      type: String,
      default: "",
    },
    order: {
      type: String,
      default: "desc",
    },
    order_by: {
      type: String,
      default: "created_at",
    },
    search: {
      type: String,
      default: "{}",
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    let params = {
      page: parseInt(props.page),
      limit: parseInt(props.limit),
      email: props.email,
      order: props.order,
      order_by: props.order_by,
      search: props.search,
    };
    const s_name = ref<string>("");
    const s_type = ref<string>("");
    const modelName = "experiences";
    const limitData = [5, 10, 20, 50, 100];
    const action_get_data = "GET_ALL_EXPERIENCE";
    store.dispatch(action_get_data, AppService.convertParams(params));
    const listData = computed(() => store.getters["listDataExperience"]);
    const totalPages = computed(() => store.getters["getExperiencePages"]);
    const totalDocs = computed(() => store.getters["getTotalExperience"]);
    const onChangePage = async (next_page) => {
      params.page = next_page;
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        modelName
      );
    };
    const onChangeLimit = async (event) => {
      let positionMax =
        params.limit * params.page > totalDocs.value
          ? totalDocs.value
          : params.limit * params.page;
      params.limit = event.target.value;
      params.page =
        Math.ceil(positionMax / params.limit) > 0
          ? Math.ceil(positionMax / params.limit)
          : 1;
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        modelName
      );
    };
    const onClickSort = async (order_by) => {
      params.order_by = order_by;
      params.order = params.order === "desc" ? "asc" : "desc";
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        modelName
      );
    };
    const onSearch = async () => {
      let searchObject = {};
      if (s_name.value && s_name.value != "") {
        searchObject["name"] = s_name.value.trim();
      }
      if (s_type.value && s_type.value != "") {
        searchObject["type"] = s_type.value;
      }
      params.search = JSON.stringify(searchObject);
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        modelName
      );
    };
    const onClickDelete = (id) => {
      Swal.fire({
        text: "Bạn chắc chắn muốn xóa chứ ?",
        icon: "warning",
        buttonsStyling: false,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        customClass: {
          confirmButton: "btn fw-bold btn-light-danger",
          cancelButton: "btn fw-bold btn-primary",
        },
      }).then(function (result) {
        let searchString = AppService.convertParams(params);
        if (result.isConfirmed) {
          store
            .dispatch("DELETE_EXPERIENCE", { id, searchString })
            .then(() => {
              Swal.fire({
                text: "Xóa thành công",
                icon: "success",
                buttonsStyling: false,
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  confirmButton: "btn fw-bold btn-light-success",
                  cancelButton: "btn fw-bold btn-light-primary",
                },
              }).then(async function (result) {
                await router.push({ name: modelName, query: params });
              });
            })
            .catch(() => {
              Swal.fire({
                text: store.getters.getErrors[0],
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Try again!",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-danger",
                },
              });
            });
        }
      });
    };
    const changeStatus = (objectUpdate) => {
      objectUpdate.id = objectUpdate._id;
      objectUpdate.active =
        objectUpdate.active == "inactive" ? "active" : "inactive";
      store.dispatch("UPDATE_EXPERIENCE", objectUpdate);
    };
    const onClickView = (id) => {
      //console.log(id);
      // DrawerComponent.initGlobalHandlers();
      // DrawerComponent.update();
    };
    const typeProject = {
      du_an: "DỰ ÁN",
      dia_diem: "ĐỊA ĐIỂM",
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Review", ["Nội dung"]);
      MenuComponent.reinitialization();
      let searchObject = JSON.parse(params.search);

      s_name.value = searchObject.name?searchObject.name:'';
      s_type.value = searchObject.type?searchObject.type:'';
    });
    const domain_FE = process.env.VUE_APP_HOME_FE;

    return {
      domain_FE,
      s_name,
      s_type,
      listData,
      modelName,
      params,
      limitData,
      totalDocs,
      totalPages,
      typeProject,
      onChangePage,
      onClickView,
      changeStatus,
      onClickDelete,
      onChangeLimit,
      onClickSort,
      renderImageUrl,
      onSearch,
    };
  },
});
